// Configuración mínima del frontend
// El resto de la configuración se carga desde el backend vía ConfigContext
var Global = {
  // API REST URL - necesaria para la llamada inicial al backend
  apiRESTUrl: process.env.REACT_APP_API_URL,

  // Syncfusion License - necesaria antes de que React se inicialice
  licenciaSyncfusion: process.env.REACT_APP_SYNCFUSION_LICENSE,
};

export default Global;
